import { initializeSignOzTracing } from '@echoteam/signoz-react';
import { Config } from 'shared/lib/config';

if (Config?.REACT_APP_NODE_ENV !== 'development') {
  initializeSignOzTracing({
    serviceName: Config?.REACT_APP_SIGNOZ_SERVICE_NAME,
    serviceVersion: Config?.REACT_APP_SIGNOZ_SERVICE_VERSION,
    environment: Config?.REACT_APP_SIGNOZ_ENV,
    serviceNamespace: Config?.REACT_APP_SIGNOZ_SERVICE_NAMESPACE,
    url: Config?.REACT_APP_SIGNOZ_URL,
    traceSampleRate: Config?.REACT_APP_SIGNOZ_TRACE_SAMPLE_RATE,
    allowedOrigins: Config?.REACT_APP_SIGNOZ_ALLOWED_ORIGINS,
  });
}
